module.exports = __webpack_public_path__ + "img/8-1.6ae78f16.png";